import { useState } from "react";
import { Popover } from "web-ui";

import type { AppStoreReleaseStatus } from "api/dashboardBackend";
import styles from "components/dashboard/release-card/per-app-store-release-status/ReleaseStatusIcon.module.scss";
import strings from "components/dashboard/release-card/per-app-store-release-status/ReleaseStatusIcon.strings.json";
import { linksToAppStoreMap } from "components/dashboard/release-card/per-app-store-release-status/linksToAppStoreMap";

interface Props {
  appStoreReleaseStatus: AppStoreReleaseStatus;
}

const ReleaseStatusIcon = ({ appStoreReleaseStatus }: Props) => {
  const [appStorePopover, setShowAppStorePopover] = useState<string | null>(
    null,
  );

  const tencentInfo = (
    <div className={styles.tencentInfo}>{strings.tencent_info}</div>
  );

  return (
    <>
      <a
        className={styles.icon}
        href={linksToAppStoreMap[appStoreReleaseStatus.app_store.toLowerCase()]}
        onMouseEnter={() =>
          setShowAppStorePopover(appStoreReleaseStatus.app_store)
        }
        onMouseLeave={() => setShowAppStorePopover(null)}
        rel="noopener noreferrer"
        style={{ backgroundColor: appStoreReleaseStatus.color }}
        target="_blank"
      >
        <div className={styles.centerIcon}>
          {appStoreReleaseStatus.app_store.charAt(0)}
        </div>
      </a>
      {appStorePopover && (
        <Popover direction="down" zIndex={100}>
          <div className={styles.popoverContent}>
            <div
              className={styles.popoverTitle}
            >{`${appStoreReleaseStatus.app_store}: `}</div>
            <div style={{ color: appStoreReleaseStatus.color }}>
              {appStoreReleaseStatus.status in strings
                ? strings[appStoreReleaseStatus.status as keyof typeof strings]
                : appStoreReleaseStatus.status}
            </div>
            {appStoreReleaseStatus.app_store.toLowerCase() === "tencent" &&
              tencentInfo}
          </div>
        </Popover>
      )}
    </>
  );
};

export default ReleaseStatusIcon;
